<template>
    <div v-if="$objBaseInfo.channelId === 'WEB'">
      <el-dialog :title="$t('cardTypeDialog.title')" v-model="dialogVisible" width="45rem" :show-close="false" :before-close="handleCancel">
        <el-divider class="title-headerDivider"></el-divider>
        <el-form ref="form" :model="formData" :rules="formRules" label-width="100px">
          <!-- 证件类型 -->
          <el-form-item :label="$t('cardTypeDialog.certificateType')" :label-width="labelWidth">
            <el-select v-model="formData.certificateType" @change="handleCertificateTypeChange" style="width: 100%">
                <el-option v-for="item in cardTypeOption" 
                  :key="item.value" 
                  :label="item.text" 
                  :value="item.value">
                </el-option>
            </el-select>
          </el-form-item>
          <template v-if="formData.certificateType === 'NI'"> <!-- 身份证 -->
            <el-form-item :label="$t('cardTypeDialog.certificateNumber')" prop="certificateNumber" :label-width="labelWidth">
              <el-input v-model="formData.certificateNumber"/>
            </el-form-item>
            <el-form-item :label="$t('cardTypeDialog.name')" prop="name" :label-width="labelWidth">
              <el-input v-model="formData.name"/>
            </el-form-item>
          </template>
          <template v-else-if="formData.certificateType === 'GATJZZ'"><!-- 港澳台居民居住证、其他 -->
            <!-- 证件号 -->
            <el-form-item :label="$t('cardTypeDialog.certificateNumber')" prop="certificateNumber" :label-width="labelWidth">
              <el-input v-model="formData.certificateNumber"/>
            </el-form-item>
            <!-- 证件姓 -->
            <el-form-item :label="$t('cardTypeDialog.lastName')" prop="lastName" :label-width="labelWidth">
              <el-input v-model="formData.lastName"/>
            </el-form-item>
            <!-- 证件名 -->
            <el-form-item :label="$t('cardTypeDialog.firstName')" prop="firstName" :label-width="labelWidth">
              <el-input v-model="formData.firstName"/>
            </el-form-item>
          </template>
          <template v-else>
            <!-- 证件号 -->
            <el-form-item :label="$t('cardTypeDialog.certificateNumber')" prop="certificateNumber" :label-width="labelWidth">
              <el-input v-model="formData.certificateNumber"/>
            </el-form-item>
            <!-- 证件姓 -->
            <el-form-item :label="$t('cardTypeDialog.lastName')" prop="lastName" :label-width="labelWidth">
              <el-input v-model="formData.lastName"/>
            </el-form-item>
            <!-- 证件名 -->
            <el-form-item :label="$t('cardTypeDialog.firstName')" prop="firstName" :label-width="labelWidth">
              <el-input v-model="formData.firstName"/>
            </el-form-item>
            <!-- 证件有效期 -->
            <el-form-item :label="$t('cardTypeDialog.expiryDate')" prop="expiryDate" :label-width="labelWidth">
              <el-date-picker
                v-model="formData.expiryDate"
                type="date"
                style="width: 100%"
                :disabled-date="disablePastDates"
              />
            </el-form-item>
            <!-- 出生日期 -->
            <el-form-item :label="$t('cardTypeDialog.birthDate')" prop="birthDate" :label-width="labelWidth">
              <el-date-picker
                v-model="formData.birthDate"
                type="date"
                style="width: 100%"
                :disabled-date="disableFutureDates"
              />
            </el-form-item>
            <!-- 性别 -->
            <el-form-item :label="$t('cardTypeDialog.gender')" prop="gender" :label-width="labelWidth">
              <el-select v-model="formData.gender" style="width: 100%">
                <el-option :label="$t('cardTypeDialog.male')" value="M" />
                <el-option :label="$t('cardTypeDialog.female')" value="F" />
              </el-select>
            </el-form-item>
            <!-- 国籍 -->
            <el-form-item :label="$t('cardTypeDialog.nationality')" prop="nationality" :label-width="labelWidth">
              <el-select filterable clearable v-model="formData.nationality" @change="selectNation" style="width: 100%">
                <el-option
                  v-for="item in getCountryListName"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <!-- 签发国 -->
            <el-form-item :label="$t('cardTypeDialog.issuingCountry')" prop="issuingCountry" :label-width="labelWidth">
              <el-select filterable clearable v-model="formData.issuingCountry" @change="selectIssuingCountry" style="width: 100%">
                <el-option
                  v-for="item in getCountryListName"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </template>
        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="handleSubmit" style="background-color: #fc6640;border:0px;">{{ $t('cardTypeDialog.save') }}</el-button>
          <el-button @click="handleCancel">{{ $t('cardTypeDialog.cancel') }}</el-button>
        </div>
      </el-dialog>
    </div>
    <div v-else>
      <!-- 移动端弹窗 -->
      <van-popup
        v-model:show="dialogVisible"
        position="bottom"
        round
        close-icon-position="top-left"
        :style="{ height: '95%' }"
        @close="handleCancel"
      >
        <van-nav-bar :title="$t('cardTypeDialog.title')" :border="false" />
        <div class="mobile-dialog-content">
          <!-- 表单内容 -->
          <van-form ref="form" :model="formData" @submit="handleSubmit">
            <!-- 证件类型 -->
            <van-field :label="$t('cardTypeDialog.certificateType')">
              <template #input>
                <van-dropdown-menu>
                  <van-dropdown-item
                    v-model="formData.certificateType"
                    :options="cardTypeOption"
                    @change="handleCertificateTypeChange"
                  />
                </van-dropdown-menu>
              </template>
            </van-field>

            <!-- 根据证件类型显示不同字段 -->
            <template v-if="formData.certificateType === 'NI'">
              <!-- 身份证 -->
              <van-field
                v-model="formData.certificateNumber"
                :label="$t('cardTypeDialog.certificateNumber')"
                :name="formData.certificateNumber"
                :rules="mobileFormRules.IdCardNumber"
                required
              />

              <van-field
                v-model="formData.name"
                :label="$t('cardTypeDialog.name')"
                :name="formData.name"
                :rules="mobileFormRules.name"
                required
              />
            </template>

            <template v-else-if="formData.certificateType === 'GATJZZ'">
              <!-- 港澳台居民居住证、其他 -->
              <van-field
                v-model="formData.certificateNumber"
                :label="$t('cardTypeDialog.certificateNumber')"
                :name="formData.certificateNumber"
                :rules="mobileFormRules.certificateNumber"
                required
              />

              <van-field
                v-model="formData.lastName"
                :label="$t('cardTypeDialog.lastName')"
                :name="formData.lastName"
                :rules="mobileFormRules.lastName"
                required
              />

              <van-field
                v-model="formData.firstName"
                :label="$t('cardTypeDialog.firstName')"
                :name="formData.firstName"
                :rules="mobileFormRules.firstName"
                required
              />
            </template>

            <template v-else-if="formData.certificateType">
              <!-- 其他证件类型 -->
              <van-field
                v-model="formData.certificateNumber"
                :label="$t('cardTypeDialog.certificateNumber')"
                :name="formData.certificateNumber"
                :rules="mobileFormRules.certificateNumber"
                required
              />

              <van-field
                v-model="formData.lastName"
                :label="$t('cardTypeDialog.lastName')"
                :name="formData.lastName"
                :rules="mobileFormRules.lastName"
                required
              />

              <van-field
                v-model="formData.firstName"
                :label="$t('cardTypeDialog.firstName')"
                :name="formData.firstName"
                :rules="mobileFormRules.firstName"
                required
              />

              <!-- 证件有效期 -->
              <van-field
                v-model="formData.expiryDate"
                :label="$t('cardTypeDialog.expiryDate')"
                :name="formData.expiryDate"
                readonly
                @click="showExpiryDatePicker = true"
                :rules="mobileFormRules.expiryDate"
                required
              />

              <!-- 出生日期 -->
              <van-field
                v-model="formData.birthDate"
                :label="$t('cardTypeDialog.birthDate')"
                :name="formData.birthDate"
                readonly
                @click="handleBirthDateClick"
                :rules="mobileFormRules.birthDate"
                required
              />

              <!-- 性别 -->
              <van-field
                :label="$t('cardTypeDialog.gender')"
                :name="formData.gender"
                :rules="mobileFormRules.gender"
                required
              >
                <template #input>
                  <van-radio-group v-model="formData.gender" direction="horizontal">
                    <van-radio name="M">{{ $t('cardTypeDialog.male') }}</van-radio>
                    <van-radio name="F">{{ $t('cardTypeDialog.female') }}</van-radio>
                  </van-radio-group>
                </template>
              </van-field>

              <!-- 国籍 -->
              <van-field
                v-model="formData.nationality"
                :label="$t('cardTypeDialog.nationality')"
                :name="formData.nationality"
                :rules="mobileFormRules.nationality"
                @click="showNationality = true"
                required
              />

              <!-- 签发国 -->
              <van-field
                v-model="formData.issuingCountry"
                :label="$t('cardTypeDialog.issuingCountry')"
                :name="formData.issuingCountry"
                :rules="mobileFormRules.issuingCountry"
                @click="showIssuingCountry = true"
                required
              />
            </template>
          </van-form>

          <!-- 操作按钮 -->
          <div class="mobile-dialog-footer">
            <van-button 
              round 
              block 
              type="primary" 
              native-type="submit"
              @click="handleSubmit"
              color="#fc6640"
              class="submit-btn"
            >
              {{ $t('cardTypeDialog.save') }}
            </van-button>
            
            <van-button 
              round 
              block 
              class="cancel-btn"
              @click="handleCancel"
            >
              {{ $t('cardTypeDialog.cancel') }}
            </van-button>
          </div>
        </div>
      </van-popup>
      <!-- 日期选择器 -->
      <van-popup :show="showExpiryDatePicker" position="bottom" round>
        <van-date-picker
          :value="tempExpiryDate"
          type="date"
          :title="$t('cardTypeDialog.expiryDate')"
          :min-date="new Date()"
          :max-date="new Date(2099, 11, 31)"
          @confirm="onExpiryDateConfirm"
          @cancel="showExpiryDatePicker = false"
        />
      </van-popup>
      <van-popup :show="showBirthDatePicker" position="bottom" round>
        <van-date-picker
          :value="tempBirthDate"
          type="date"
          :title="$t('cardTypeDialog.birthDate')"
          :min-date="new Date(1925, 0, 1)"
          :max-date="new Date()"
          @confirm="onBirthDateConfirm"
          @cancel="showBirthDatePicker = false"
        />
      </van-popup>
      <van-popup :show="showNationality" position="bottom" round>
        <form>
          <van-search v-model="formData.inputNationality">
          </van-search>
          <van-picker
            show-toolbar
            :columns="getCountryListName"
            @confirm="pickerConfirm"
            @cancel="pickerCancel"
          />
        </form>
      </van-popup>
      <van-popup :show="showIssuingCountry" position="bottom" round>
        <form>
          <van-search v-model="formData.inputIssuingCountry">
          </van-search>
          <van-picker
            show-toolbar
            :columns="getCountryListName"
            @confirm="issuingCountryConfirm"
            @cancel="issuingCountryCancel"
          />
        </form>
      </van-popup>
    </div>
</template>

<script>
import { formatDateTime } from "@/utils/utils.js";
import { getcountryList } from "@/api/shoppingData";
import { addTemporary } from "@/api/platformData";
export default {
  name: 'CardTypeDialog',
  props: {
    centerDialogVisible: Boolean,
    cardType:String,
    isTemporary:Boolean,
    lKPKID:Number,
    loginid : String,
    userid : [Number, String],
  },
  data() {
    return {
      dialogVisible: false,
      cardTypeOption:[],
      countryNameListOptions:[],
      countryListOriginalData:[],
      showBirthDatePicker: false,
      showExpiryDatePicker: false,
      showNationality: false,
      showIssuingCountry: false,
      tempExpiryDate: new Date(),  // 临时存储选择的日期
      tempBirthDate: new Date(),   // 临时存储选择的日期
      formData: {
        certificateType: 'NI',
        certificateNumber: '',
        lastName: '',
        firstName: '',
        name: '',
        birthDate: '',
        gender: '',
        expiryDate: '',
        nationality: '',
        nationalityCode: '',
        issuingCountry: '',
        issuingCountryCode: '',
        inputNationality: '',
        inputIssuingCountry: '',
      },
    }
  },
  created() {
    this.getCountryList();
  },
  updated() {
    this.cardTypeOption = this.getCardTypeSelect;
    this.countryNameListOptions = this.getCountryListName;
  },
  computed: {
    labelWidth() {
      return this.$i18n.locale === 'en' ? '150px' : '100px';
    },
    getCardTypeSelect() {
      return [
        { text: this.$t("cardTypes.IdCard"), value: "NI" },
        { text: this.$t("cardTypes.Passport"), value: "FOID" },
        { text: this.$t("cardTypes.HomeReturnPermit"), value: "RP" },
        { text: this.$t("cardTypes.TaiwanCard"), value: "TCC" },
        { text: this.$t("cardTypes.OfficerCard"), value: "JG" },
        { text: this.$t("cardTypes.HongKongAndMacaoPass"), value: "MP" },
        { text: this.$t("cardTypes.TaiWanPass"), value: "TWP" },
        { text: this.$t("cardTypes.HkAndMacauPass"), value: "GATJZZ" },
        { text: this.$t("cardTypes.ForeignPermanentResidentCard"), value: "PRC" },
      ];
    },
    getCountryListName() {
      const originalList = this.countryListOriginalData.map(country => ({
        text: this.$i18n.locale === 'en' 
              ? country.countryNameLists?.en 
              : country.countryNameLists?.["zh-CN"],
        value: country.countryCode
      }));
      // 添加新数据
      const additionalData = [
        { text: this.$i18n.locale === 'en' ? 'China Macau' : '中国澳门',value: 'MO'},
        { text: this.$i18n.locale === 'en' ? 'China Taiwan' : '中国台湾',value: 'TW'},
        { text: this.$i18n.locale === 'en' ? 'China Hong Kong' : '中国香港',value: 'HK'},
      ];
      const countryData = [...originalList, ...additionalData];
      let  filterValue = null;
      if(this.showIssuingCountry){
        filterValue = this.formData.inputIssuingCountry?.trim().toLowerCase();
      }
      if(this.showNationality){
        filterValue = this.formData.inputNationality?.trim().toLowerCase();
      }
      if (!filterValue) {
        return countryData;
      }
      return countryData.filter(country =>
        country.text.toLowerCase().includes(filterValue)
      );
    },
    formRules() {
      return {
        certificateNumber: [
          { required: true, message: this.$t("cardTypeRules.IdCardEmpty"), trigger: 'blur' },
          { validator: this.validateCertificateNumber, trigger: 'blur' }
        ],
        name: [
          { required: true, message: this.$t("cardTypeRules.NameEmpty"), trigger: 'blur' },
          { validator: this.validateChineseNameFinal, trigger: 'blur' }
        ],
        lastName: [
          { required: true, message: this.$t("cardTypeRules.SurnameEmpty"), trigger: 'blur' },
          { validator: this.validateChineseName, trigger: 'blur' },
          { validator: this.validateEnglishName, trigger: 'blur' }
        ],
        firstName: [
          { required: true, message: this.$t("cardTypeRules.GivenNameEmpty"), trigger: 'blur' },
          { validator: this.validateChineseName, trigger: 'blur' },
          { validator: this.validateEnglishName, trigger: 'blur' }
        ],
        expiryDate: [
          { required: true, message: this.$t("cardTypeRules.expiryDateInvalid"), trigger: ["blur", "change"] }
        ],
        birthDate: [
          { required: true, message: this.$t("cardTypeRules.birthDateInvalid"), trigger: ["blur", "change"] },
        ],
        gender: [
          { required: true, message: this.$t("cardTypeRules.genderInvalid"), trigger: ["blur", "change"] }
        ],
        nationality: [
          { required: true, message: this.$t("cardTypeRules.notionalityInvalid"), trigger: 'blur' },
        ],
        issuingCountry: [
          { required: true, message: this.$t("cardTypeRules.issuingCountryInvalid"), trigger: 'blur' },
        ]
      }
    },
    mobileFormRules() {
      return {
        certificateNumber: [{ required: true, message: this.$t("cardTypeRules.IdCardEmpty")},
          { validator: (value) => this.validateCertificateNumber(value),message: this.$t("cardTypeRules.CardNumberInvalid")}],
        IdCardNumber: [{ required: true, message: this.$t("cardTypeRules.IdCardEmpty")},
          { validator: (value) => this.validateCertificateNumber(value),message: this.$t("cardTypeRules.IdCardInvalid")}],
        name: [{ required: true, message: this.$t("cardTypeRules.NameEmpty")},
          { validator: (value) => this.validateChineseNameFinal(value),message: this.$t("cardTypeRules.NameInvalid")}],
        lastName: [{ required: true, message: this.$t("cardTypeRules.SurnameEmpty")},
          { validator: (value) => this.validateChineseName(value),message: this.$t("cardTypeRules.CertificateNameInvalid")},
          { validator: (value) => this.validateEnglishName(value),message: this.$t("cardTypeRules.CertificateEngNameInvalid")}],
        firstName: [{ required: true, message: this.$t("cardTypeRules.GivenNameEmpty")},
          { validator: (value) => this.validateChineseName(value),message: this.$t("cardTypeRules.CertificateNameInvalid")},
          { validator: (value) => this.validateEnglishName(value),message: this.$t("cardTypeRules.CertificateEngNameInvalid")}],
        expiryDate: [{ required: true, message: this.$t("cardTypeRules.expiryDateInvalid")}],
        birthDate: [{ required: true, message: this.$t("cardTypeRules.birthDateInvalid")}],
        gender: [{ required: true, message: this.$t("cardTypeRules.genderInvalid")}],
        nationality: [{ required: true, message: this.$t("cardTypeRules.notionalityInvalid")}],
        issuingCountry: [{ required: true, message: this.$t("cardTypeRules.issuingCountryInvalid") }]
      }
    },
  },
  watch: {
    centerDialogVisible(newVal) {
      if(this.$objBaseInfo.channelId === 'WEB'){
        // 清除验证错误
        this.$refs.form?.clearValidate()
      }else{
        this.$refs.form?.resetValidation()
      }
      this.dialogVisible = newVal;
    },
    cardType(newVal) {
      if(this.formData.certificateType !== newVal){
        this.handleCertificateTypeChange(newVal);
      }
      this.formData.certificateType = newVal;
    }
  },
  
  methods: {
    disablePastDates(time){
      return time.getTime() < Date.now() - 8.64e7;
    },
    disableFutureDates(time){
      return time.getTime() > Date.now();
    },
    handleCertificateTypeChange(value) {
      // 清空逻辑
      const clearData = {
        certificateNumber: '',
        lastName: '',
        firstName: '',
        name: '',
        birthDate: '',
        gender: '',
        expiryDate: '',
        nationality: '',
        issuingCountry: '',
        inputNationality: '',
        inputIssuingCountry: '',
      }
      
      // 应用清空
      Object.assign(this.formData, clearData)
      
      if(this.$objBaseInfo.channelId === 'WEB'){
        // 清除验证错误
        this.$refs.form?.clearValidate()
      }else{
        this.$refs.form?.resetValidation()
      }
    },
     // 证件号码验证 - 统一版本
    validateCertificateNumber(rule, value, callback) {
      // 适配 Element UI（有 callback）和 Vant（无 callback）
      const isVant = this.$objBaseInfo.channelId !== 'WEB' // Vant 只传 value
      const val = isVant ? rule : value
      const cb = isVant ? null : callback
      if (!val) {
        const error = new Error(this.$t("cardTypeRules.IdCardEmpty"))
        return isVant ? false : cb(error)
      }
      
      const type = this.formData.certificateType
      let isValid = true
      let errorMessage = ''
      
      if (type === 'NI') {
        var idCardRegex = /^[1-9]\d{5}[1-9]\d{3}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))\d{3}(\d|x|X)$/
        isValid = idCardRegex.test(val)
        if (!isValid) {
          isValid = false
          errorMessage = this.$t("cardTypeRules.IdCardFormat")
        } else if (val.length !== 18) {
          isValid = false
          errorMessage = this.$t("cardTypeRules.IdCardInvalid")
        }
      } else if (type === 'GATJZZ') {
        var gatjzzRegex = /^[1-9]\d{5}[1-9]\d{3}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))\d{3}(\d|x|X)$/
        isValid = gatjzzRegex.test(val)
        if (!isValid) {
          isValid = false
          errorMessage = this.$t("cardTypeRules.IdCardFormat")
        } else if (val.length !== 18) {
          isValid = false
          errorMessage = this.$t("cardTypeRules.CardNumberInvalid")
        }
      } 
      if (isVant) {
        return isValid
      } else {
        if (isValid) {
          cb()
        } else {
          cb(new Error(errorMessage))
        }
      }
    },
    // 身份证姓名验证 - 统一版本
    validateChineseNameFinal(rule, value, callback) {
      const isVant = this.$objBaseInfo.channelId !== 'WEB'
      const val = isVant ? rule : value
      const cb = isVant ? null : callback
      
      if (!val) {
        const error = new Error(this.$t("cardTypeRules.NameEmpty"))
        return isVant ? false : cb(error)
      }
      
      const idCardPrefix = "身份证"
      const chineseRegex = /^[\u4e00-\u9fa5]+$/
      const isValid = chineseRegex.test(val) && !val.includes(idCardPrefix)
      
      if (isVant) {
        return isValid
      } else {
        if (isValid) {
          cb()
        } else {
          cb(new Error(this.$t("cardTypeRules.NameInvalid")))
        }
      }
    },
    validateEnglishName(rule, value, callback) {
      const isVant = this.$objBaseInfo.channelId !== 'WEB'
      const val = isVant ? rule : value
      const cb = isVant ? null : callback

      const type = this.formData.certificateType
      if(type === 'TWP' || type === 'MP'){
        const englishRegex = /^[A-Za-z\s]+$/
        const isValid = englishRegex.test(val)
         if (isVant) {
          return isValid
        } else {
          if (isValid) {
            cb()
          } else {
            cb(new Error(this.$t("cardTypeRules.CertificateEngNameInvalid")))
          }
        }
      }
      // 其他类型不验证，直接通过
      return isVant ? true : cb()
    },
    // 中文姓名验证 - 统一版本
    validateChineseName(rule, value, callback) {
      const isVant = this.$objBaseInfo.channelId !== 'WEB'
      const val = isVant ? rule : value
      const cb = isVant ? null : callback
      
      const type = this.formData.certificateType
      if (type === 'GATJZZ') {
        const chineseRegex = /^[\u4e00-\u9fa5]+$/
        const isValid = chineseRegex.test(val)
        
        if (isVant) {
          return isValid
        } else {
          if (isValid) {
            cb()
          } else {
            cb(new Error(this.$t("cardTypeRules.CertificateNameInvalid")))
          }
        }
      }
      // 其他类型不验证，直接通过
      return isVant ? true : cb()
    },
    // 提交按钮
    handleSubmit() {
      console.log("提交表单数据:", this.formData);
      const isVant = this.$objBaseInfo.channelId !== 'WEB';
      let param  = {
        loginid : this.loginid,
        userid : this.userid,//this.$objBaseInfo.pkid,
        userCode : this.$objBaseInfo.customerCode,
        cardType: this.formData.certificateType,
        cardID : this.formData.certificateNumber,
        isTemporary : this.isTemporary,
        lKPKID : this.lKPKID,
      };
      if(isVant){
        this.$refs.form.validate().then(() => {
          switch(this.formData.certificateType){
            case 'NI':
              param.psgName = this.formData.name;
              break;
            case 'GATJZZ':
              param.lastName = this.formData.lastName;
              param.firstName = this.formData.firstName;
              break;
            default:
              param.lastName = this.formData.lastName;
              param.firstName = this.formData.firstName;
              param.cardValidDate = this.formData.expiryDate;
              param.birthDay = this.formData.birthDate;
              param.sex = this.formData.gender;
              param.visaCountry = this.formData.issuingCountryCode;
              param.country = this.formData.nationalityCode;
          }
          console.log("提交参数:", param);
          addTemporary(param).then((res)=>{
            if(res.code == 200){
              this.$emit('cardTypeSubmit', this.formData);
              this.dialogVisible = false;
            }
          });
        }).catch(() => {
          // 验证失败处理
        });
      }else{
        this.$refs["form"].validate((valid) => {
          if (valid) {
            switch(this.formData.certificateType){
              case 'NI':
                param.psgName = this.formData.name;
                break;
              case 'GATJZZ':
                param.lastName = this.formData.lastName;
                param.firstName = this.formData.firstName;
                break;
              default:
                param.lastName = this.formData.lastName;
                param.firstName = this.formData.firstName;
                param.cardValidDate = this.formData.expiryDate;
                param.birthDay = this.formData.birthDate;
                param.sex = this.formData.gender;
                param.visaCountry = this.formData.issuingCountryCode;
                param.country = this.formData.nationalityCode;
            }
            console.log("提交参数:", param);
            addTemporary(param).then((res)=>{
              if(res.code == 200){
                this.$emit('cardTypeSubmit', this.formData);
                this.dialogVisible = false;
              }
            });
          }
        });
      }
      // 触发提交事件，将表单数据传递给父组件
    //   this.$emit('submit', this.formData)
    //   this.visible = false
    },
    
    // 取消按钮
    handleCancel() {
      this.dialogVisible = false;
      this.$emit('cancelCardTypeDialog');
    },
    onBirthDateConfirm(date) {
      const selectedDate = date.selectedValues[0] + '-' + date.selectedValues[1].toString().padStart(2, '0') + '-' + date.selectedValues[2].toString().padStart(2, '0');
      this.formData.birthDate = formatDateTime(selectedDate,"YYYY-MM-DD");
      this.showBirthDatePicker = false;
    },
    onExpiryDateConfirm(date) {
      const selectedDate = date.selectedValues[0] + '-' + date.selectedValues[1].toString().padStart(2, '0') + '-' + date.selectedValues[2].toString().padStart(2, '0');
      this.formData.expiryDate = formatDateTime(selectedDate,"YYYY-MM-DD");
      this.showExpiryDatePicker = false;
    },
    handleBirthDateClick() {
      this.showBirthDatePicker = true;
    },
    async getCountryList() {
      let searchparams = {
        params: {
          countryCode: "",
        },
      };
      await getcountryList(searchparams)
        .then((res) => {
          if(res.code==200 && res.data.list.length > 0){
            this.countryListOriginalData = res.data.list;
          }
        });
    },
    pickerConfirm(value){
      if(value.selectedOptions[0].value == '100000'){
        this.formData.nationalityCode = 'CN';
      }else{
        this.formData.nationalityCode = value.selectedOptions[0].value;
      }
      this.formData.nationality = value.selectedOptions[0].text;
      this.showNationality = false;
    },
    pickerCancel(){
      this.showNationality = false;
    },
    issuingCountryConfirm(value){
      if(value.selectedOptions[0].value == '100000'){
        this.formData.issuingCountryCode = 'CN';
      }else{
        this.formData.issuingCountryCode = value.selectedOptions[0].value;
      }
      this.formData.issuingCountry = value.selectedOptions[0].text;
      this.showIssuingCountry = false;
    },
    issuingCountryCancel(){
      this.showIssuingCountry = false;
    },
    selectNation(value){
      if(value == '100000'){
        this.formData.nationalityCode = 'CN';
      }else{
        this.formData.nationalityCode = value;
      }
    },
    selectIssuingCountry(value){
      if(value == '100000'){
        this.formData.issuingCountryCode = 'CN';
      }else{
        this.formData.issuingCountryCode = value;
      }
    },
  }
}
</script>

<style scoped>
.dialog-footer {
  text-align: center;
}
.title-headerDivider {
  margin-bottom: 1rem;
  margin-top: -1rem;
  height: 2px;
  background-color: #fc6640;
}
::v-deep .el-dialog__body {
  padding-top: 10px;
  padding-bottom: 0;
}
::v-deep .el-form-item {
  margin-bottom: 15px;
}
.mobile-dialog-content {
  padding: 20px 16px;
  height: calc(100% - 100px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.mobile-dialog-content .van-form{
  padding-bottom: 30px;
}
::v-deep .van-dropdown-menu__bar {
  height: 0;
  box-shadow: none;
}
.mobile-dialog-footer .submit-btn {
  margin-bottom: 12px;
}
.mobile-dialog-footer .cancel-btn {
  border: 1px solid #ebedf0;
  color: #323233;
}
</style>